import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useAnswerContext } from '../../context';
import {
  Link,
  Button,
  makeStyles,
  Paper,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { BarPicture, Picture } from './picture';

export const getText = (sum: number) => {
  if (sum === 1) {
    return 'Experimenting';
  }
  if (sum === 2) {
    return 'Transitioning';
  }
  if (sum === 3) {
    return 'Optimizing';
  }
  return 'Transforming';
};

const styles = [
  {
    color: '#E37400',
    background: '#FFD648',
  },
  {
    color: '#EA4335',
    background: '#FAD2CF',
  },
  {
    color: '#34A853',
    background: '#CEEAD6',
  },
  {
    color: '#4285F4',
    background: '#D2E3FC',
  },
];

const stylesLight = [
  {
    color: '#FBBC04',
  },
  {
    color: '#EA4335',
  },
  {
    color: '#34A853',
  },
  {
    color: '#4285F4',
  },
];
const getYouAreHere = (num: number, summary: number, className: string) => {
  return summary === num ? (
    <div className={className} style={styles[num - 1] as any}>
      You are here
    </div>
  ) : (
    <div></div>
  );
};

const getColor = (num: number | null, summary: number) => {
  if (num === null) {
    return styles[summary - 1].color;
  }
  return num === summary ? styles[num - 1].color : '#9AA0A6';
};
const getLightColor = (num: number | null, summary: number) => {
  if (num === null) {
    return stylesLight[summary - 1].color;
  }
  return num === summary ? stylesLight[num - 1].color : '#9AA0A6';
};
const getColorWithPreviousIncluded = (num: number | null, summary: number) => {
  if (num === null) {
    return styles[summary - 1].color;
  }
  return num <= summary ? stylesLight[num - 1].color : '#9AA0A6';
};
const useStyles = makeStyles((theme) => ({
  root: {
    margin: '30px',
    marginTop: 93,
    display: 'flex',
    flexDirection: 'column',
    width: 900,
    maxWidth: '90%',
    zIndex: 2,
  },
  paper: {
    maxWidth: 900,
    borderRadius: 15,
    position: 'relative',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 2px 13px 0px',
  },
  accordin: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignContent: 'center',
    margin: '0 auto',
    alignSelf: 'stretch',
  },
  images: {
    marginTop: 70,
    marginBottom: 20,
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '10px 10px',
  },
  coloredLine: {
    position: 'absolute',
    top: 0,
    margin: 'auto',
    height: 5,
    width: 150,
    left: 'calc(50% - 75px)',
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
  bar: {
    height: 5,
    marginLeft: -10,
  },
  text: {
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    textAlign: 'center',
  },
  retake: {
    padding: '12px 24px',
    boxShadow: 'none',
    background: '#fff',
    border: '1px solid #dadce0',
    color: '#1a73e8',
    fontSize: 16,
    fontWeight: 500,
    outline: 'none',
    '&:hover': {
      background: '#f6f9fe',
      borderColor: '#1a73e8',
      color: '#174ea6',
      boxShadow: 'none',
      outline: 'none',
    },
    '&:focus': {
      background: '#e4eefc',
      borderColor: '#1a73e8',
      boxShadow: '0 0 0 1px #1a73e8 !important',
      color: '#174ea6',
      outline: 'none',
    },
    '&:active': {
      background: '#e8f1fd',
      borderColor: '#1a73e8',
      boxShadow: 'none !important',
      color: '#174ea6',
      outline: 'none',
    },
  },
  logo: {
    marginLeft: '-15px',
    alignSelf: 'center',
  },
  onlyDesktopBreak: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  accordinMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  headerStay: {
    color: '#202124',
    textAlign: 'center',
    fontWeight: 500,
    margin: '10px 20px',
    [theme.breakpoints.down('md')]: {
      fontSize: '34px',
      lineHeight: '37px',
      letterSpacing: '-0.23px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '44px',
      lineHeight: '52px',
      letterSpacing: '-0.5px',
    },
  },
  googleHelp: {
    color: '#5f6368',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
    margin: '0px 20px',
    [theme.breakpoints.down('md')]: {
      marginTop: 45,
    },
  },
  paragraph: {
    maxWidth: 510,
    alignSelf: 'center',
    textAlign: 'center',
    fontSize: '18px',
    lineHeight: '30px',
    letterSpacing: '0.2px',
  },
  desc: {
    textAlign: 'center',
    fontSize: 18,
    lineHeight: '38px',
    fontWeight: 500,
    letterSpacing: '0.2px',
  },
  headerLogo: {
    alignSelf: 'center',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  },
  here: {
    textAlign: 'center',
    fontFamily: '"Google Sans", Roboto, sans-serif',
    fontSize: 12,
    lineHeight: '12px',
    fontWeight: 500,
    letterSpacing: '0.06px',
    padding: '6px 20px',
    borderRadius: '100px',
    justifySelf: 'center',
    width: 110,
  },
  paperText1: {
    display: 'flex',
    justifyContent: 'center',
    color: '#202124',
    textAlign: 'center',
    ['& a']: {
      display: 'contents',
      color: '#1A73E8',
      textDecoration: 'none',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
      lineHeight: '32px',
      margin: '50px 20px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '28px',
      lineHeight: '46px',
      letterSpacing: '0.3px',
      margin: '50px 40px',
    },
  },
  paperText2: {
    margin: '50px 20px',
    color: '#5F6368',
    [theme.breakpoints.down('md')]: {
      fontSize: '23px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '24px',
      lineHeight: '38px',
      letterSpacing: '0.2px',
    },
  },
}));

const resultText: Array<[string, string]> = [
  [
    'You’re trying different ways to achieve functional alignment and scale the logistics functions to reduce operating costs. You may have piloted applications and are using operational data to create proofs of concept using machine learning and artificial intelligence.',
    'Your next step is to focus on interoperability across disjoint data sets - internal ERPs, supply chain systems, financial records and external trading partners’ data - for deeper analysis and stronger insights. <a target="_blank" href="https://services.google.com/fh/files/misc/how_data_is_driving_resilient_sustainable_supply_chain_2021.pdf">Download our whitepaper</a> to learn about the intuitive tools that improve interoperability and guide your data-driven decisions',
  ],
  [
    'You understand the value of breaking down data silos and are able to scale the logistics function to reduce costs. By creating a cloud-based data lake across logistics systems and facilities, you’re focusing on real-time, data-driven analysis.',
    'Your next step is to introduce advanced analytics and AI to improve business outcomes. Check how industry peers have built resilient and sustainable supply chains <a target="_blank" href="https://cloudonair.withgoogle.com/events/summit-manufacturing?utm_source=assessment&utm_medium=email&utm_campaign=FY21-Q3-northam-NA1349-website-dl-manu_supply_chain-assessment&utm_content=supply-chain-assessment">using Google Cloud.</a>',
  ],
  [
    'Your decisions are driven by real-time data to improve business outcomes, shorten procurement cycles, and lower costs.',
    'Your next step is to integrate insights directly into workflows, improve collaboration with external stakeholders, and share models and analytics. An open and unified data platform with innovative data sharing and data analysis functions will help you integrate your logistics capabilities with those of key value chain partners, such as customers and suppliers. <a target="blank" href="https://cloudonair.withgoogle.com/events/digital-supply-chain-launch">Attend our industry event</a> to learn about digital supply chain twins and scaling insights with Google Cloud.',
  ],
  [
    'You’ve leveraged rich data for supply chain analytics. AI models have been incorporated into routine business and operational workflows, reducing cost and improving quality.',
    'You’ve done the heavy lifting. Now, let’s explore how AI can power your data-driven future. Talk to our solutions team to learn how Google Cloud can help you deliver high-performing recommendations across channels and leverage industry AI models on Google Cloud Platform. Learn more about the <a target="_blank" href="https://cloudonair.withgoogle.com/events/digital-supply-chain-launch#">supply chain twin solution of Google Cloud</a> and how it can help you optimize decision making.',
  ],
];

export const Result = () => {
  const {
    accordin,
    images,
    headerStay,
    logo,
    root,
    here,
    paper,
    headerLogo,
    desc,
    bar,
    paperText1,
    coloredLine,
    googleHelp,
    onlyDesktopBreak,
    accordinMobile,
  } = useStyles();
  const { values, retake: retakeHandler } = useAnswerContext();
  const imagesRef = useRef<HTMLDivElement>(null);
  const history = useHistory<any>();

  useEffect(() => {
    if (!history.location.state?.complete) {
      const search = history.location.search;
      history.push(
        history.location.pathname
          ? history.location.pathname + search
          : '/' + search,
        { complete: true },
      );
    }
  }, [history]);

  useEffect(() => {
    const unlisten = history.listen((x: any) => {
      if (x.state?.activeStep) {
        retakeHandler('7');
      }
    });
    return () => {
      unlisten();
    };
  }, [history, retakeHandler]);
  let q3Sum = values.q3.reduce((a, b) => a + b, 0);

  let score =
    values.q2 + q3Sum + values.q4.length + values.q5.length + values.q7;
  let summary = 1;
  if (score > 20) summary = 4;
  else if (score > 15) summary = 3;
  else if (score > 10) summary = 2;

  // summary =1;
  useLayoutEffect(() => {
    if (!imagesRef.current) {
      return;
    }
    imagesRef.current.scrollIntoView();
  }, []);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <div className={root}>
        <div>
          <div className={headerLogo} ref={imagesRef}>
            <img
              className={logo}
              width="200"
              src={process.env.PUBLIC_URL + '/google_cloud_logo_healthcare.png'}
              alt="google cloud logo"
            />
            <h2 className={headerStay}>
              Discover where your organization is on its data-drive supply chain
              journey
            </h2>
            <p className={googleHelp}>
              Whether you’re experimenting, transitioning, optimizing, or
              transforming,
              <br className={onlyDesktopBreak} /> Google Cloud helps you take
              your next best step.
            </p>

            <Link
              underline="none"
              target="blank"
              href={`https://cloud.google.com/contact?utm_source=cloud_sfdc&utm_medium=email&utm_campaign=FY21-Q3-northam-NA1349-website-dl-manu_supply_chain-assessment&utm_content=supply-chain-assessment`}
            >
              <Button
                color="primary"
                style={{ marginTop: 50 }}
                variant="contained"
              >
                Contact sales
              </Button>
            </Link>
          </div>
        </div>
        {matches ? (
          <div className={accordinMobile}>
            <Picture id={summary} summary={summary} />
            {getYouAreHere(1, summary, here)}
            {getYouAreHere(2, summary, here)}
            {getYouAreHere(3, summary, here)}
            {getYouAreHere(4, summary, here)}
            <div className={desc} style={{ color: getColor(null, summary) }}>
              {getText(summary)}
            </div>
          </div>
        ) : (
          <div className={accordin}>
            <div className={images}>
              <Picture id={1} summary={summary} />
              <Picture id={2} summary={summary} />
              <Picture id={3} summary={summary} />
              <Picture id={4} summary={summary} />
              {getYouAreHere(1, summary, here)}
              {getYouAreHere(2, summary, here)}
              {getYouAreHere(3, summary, here)}
              {getYouAreHere(4, summary, here)}
              <div
                className={bar}
                style={{
                  backgroundColor: getColorWithPreviousIncluded(1, summary),
                }}
              >
                {' '}
                <BarPicture id={1} summary={summary} />
              </div>
              <div
                className={bar}
                style={{
                  backgroundColor: getColorWithPreviousIncluded(2, summary),
                }}
              >
                {' '}
                <BarPicture id={2} summary={summary} />
              </div>
              <div
                className={bar}
                style={{
                  backgroundColor: getColorWithPreviousIncluded(3, summary),
                }}
              >
                {' '}
                <BarPicture id={3} summary={summary} />
              </div>
              <div
                className={bar}
                style={{
                  backgroundColor: getColorWithPreviousIncluded(4, summary),
                }}
              >
                <BarPicture id={4} summary={summary} />
              </div>
              <div className={desc} style={{ color: getColor(1, summary) }}>
                Experimenting
              </div>
              <div className={desc} style={{ color: getColor(2, summary) }}>
                Transitioning
              </div>
              <div className={desc} style={{ color: getColor(3, summary) }}>
                Optimizing
              </div>
              <div className={desc} style={{ color: getColor(4, summary) }}>
                Transforming
              </div>
            </div>
          </div>
        )}
        <Paper className={paper}>
          {matches ? (
            <div
              className={coloredLine}
              style={{
                background: getLightColor(null, summary),
              }}
            ></div>
          ) : (
            <div
              className={coloredLine}
              style={{
                background: getLightColor(null, summary),
                transform: `translateX(${
                  summary === 1
                    ? -315
                    : summary === 2
                    ? -110
                    : summary === 3
                    ? 100
                    : 320
                }px)`,
              }}
            ></div>
          )}
          <p
            dangerouslySetInnerHTML={{ __html: resultText[summary - 1][0] }}
            className={paperText1}
          >
            {}
          </p>
          <p
            dangerouslySetInnerHTML={{ __html: resultText[summary - 1][1] }}
            className={paperText1}
          >
            {}
          </p>
        </Paper>
      </div>
    </>
  );
};
